module.exports = __webpack_public_path__ + "img/35.ff7afb52.jpg";